<template>
  <div v-if="openDialog" class="dialog-overlay" @click="cancelDelete">
    <div class="dialog" @click.stop>
      <header>
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to delete this content?</p>
      </header>
      <div class="dialog-body">
        <div class="modal-actions">
          <button
            @click="confirmDelete"
            :disabled="loading"
            class="delete-button"
          >
            <span v-if="loading" class="spinner"></span>
            <span v-else>Yes</span>
          </button>
          <button @click="cancelDelete" class="btn btn-secondary">No</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from "vue";

// Api
import axios from "axios";
import { getBaseUrl } from "@/helper/constant.js";

const props = defineProps({
  id: {
    type: [String, Number, null],
    required: true,
  },
  openDialog: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["confirm-delete", "cancel-delete"]);

const loading = ref(false);

const confirmDelete = async () => {
  if (loading.value || !props.id) return;
  loading.value = true;
  try {
    const response = await axios.delete(`${getBaseUrl()}/core/content`, {
      params: { id: props.id },
    });
    window.alert("Content Deleted Successfully");
  } catch (err) {
    console.log(err);
    window.alert(
      "There was an error deleting the content. Please Content a developer",
    );
  } finally {
    loading.value = false;
    emit("confirm-delete", props.id);
  }
};
const cancelDelete = () => {
  emit("cancel-delete");
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: slide-down 0.3s ease-out;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.dialog-body {
  max-height: 70vh;
  overflow-y: auto;
}

.modal-actions {
  gap: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.delete-content-dialog .modal-actions {
  margin-top: 20px;
}

.delete-content-dialog .btn {
  margin: 0 10px;
}

.delete-button {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes slide-down {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
